export default {

  methods: {
    findSelection(category, objName) {
      const domain = this.$store.state.categories.find((obj) => obj.category === category);
      if (!domain) return null;
      // DFS the domain for the correct option
      for (const opt of domain.options) {
        if (!opt.children.length && opt.key === objName) {
          return opt;
        }
        if (!opt.children.length) {
          continue;
        }
        for (const child of opt.children) {
          if (child.key === objName) {
            return child;
          }
        }
      }
      return null;
    },
  }
}